// extracted by mini-css-extract-plugin
var _1 = "RentalPortalIntegrations-modulewidgets__wgIi0";
export { _1 as "widgets" }
